import { useState, useRef } from 'react';

// Custom hook for managing dropdown state
const useDropdown = (initialValue) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(initialValue);
  const dropdownRef = useRef(null);
  
  const toggle = (otherDropdowns) => {
    setIsOpen(!isOpen);
    // Close other dropdowns if provided
    if (otherDropdowns) {
      otherDropdowns.forEach(dropdown => dropdown.setIsOpen(false));
    }
  };
  
  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
  };
  
  return {
    isOpen,
    setIsOpen,
    selected,
    setSelected,
    toggle,
    handleSelect,
    dropdownRef
  };
};

export default useDropdown;